import { useRef, useState } from 'react';
import classes from 'classnames';
import '../assets/styles/components/_app-banner.scss';
import { useAppSelector } from '@/store';
import { authSelector } from '@/store/reducers/auth';
import UserUtils from '@/utils/user';
import SVG from 'react-inlinesvg';

import logoNew from '@/assets/svg/logo_new.svg';
import common from '@/utils/common';
import NotificationsBadge from '@/components/Notifications/NotificationsBadge/NotificationsBadge';
import UserDropdown from '@/components/school-management/UserDropdown/UserDropdown';
import { useDrawer } from '@/context/DrawerContext';
import SettingsModal from '@/admin/components/SettingsModal/SettingsModal';

interface AppBannerProps {
  className?: string;
}

const AppBanner = ({ className }: AppBannerProps) => {
  const { user } = useAppSelector(authSelector);
  const isTeacher = UserUtils.isTeacher(user);
  const isStudent = UserUtils.isStudent(user);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const avatarButtonRef = useRef<HTMLButtonElement>(null);
  const drawer = useDrawer();

  const firstName = user?.metadata?.firstName ?? '';
  const lastName = user?.metadata?.lastName ?? '';
  const avatarName = user?.metadata?.userSettings?.avatar?.avatarName;
  const avatarColor = (user?.metadata?.userSettings?.avatar as any)?.avatarColor ?? '';
  const avatarImg = avatarName ? common.getAvatarImage(avatarName) : null;
  const avatarInitials = common.getInitials(firstName, lastName);

  return (
    <>
      <div className={classes('app-banner-light', className)}>
        <img className='app-banner-light-logo' src={logoNew} alt='Hello Britannica' />
        <div className='app-banner-light-right'>
          <NotificationsBadge />
          <button
            ref={avatarButtonRef}
            className='app-banner-light-avatar-btn'
            onClick={() => setIsDropdownOpen(prev => !prev)}
            aria-label='Open user menu'
            aria-haspopup='true'
            aria-expanded={isDropdownOpen}
          >
            <div
              className='app-banner-light-avatar-circle'
              style={{ backgroundColor: avatarColor || (isStudent ? '#3ad0f9' : undefined) }}
            >
              {avatarImg ? (
                <SVG src={avatarImg} className='app-banner-light-avatar-svg' />
              ) : (
                <span className='app-banner-light-avatar-initials'>{avatarInitials}</span>
              )}
            </div>
          </button>
          <div className='app-banner-light-dropdown'>
            <UserDropdown
              isOpen={isDropdownOpen}
              isStudent={isStudent}
              onOpenSettings={isStudent ? () => setIsSettingsOpen(true) : drawer.openDrawer}
              onContactUs={drawer.openContactUsDrawer}
              onClose={() => setIsDropdownOpen(false)}
              anchorRef={avatarButtonRef}
            />
          </div>
        </div>
      </div>
      {isStudent && (
        <SettingsModal show={isSettingsOpen} onClose={() => setIsSettingsOpen(false)} />
      )}
    </>
  );
};

export default AppBanner;
